// タブ切り替え
document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".rankinglp-tab a");
  const contents = document.querySelectorAll(".rankinglp-content");

  function activateTabById(targetId) {
    // 全タブリンクの is-active クラス外して、対象idのhrefだけ is-active に
    tabLinks.forEach(link => {
      if (link.getAttribute("href") === `#${targetId}`) {
        link.classList.add("is-active");
      } else {
        link.classList.remove("is-active");
      }
    });

    // 全コンテンツ非表示にして、対象だけ表示
    contents.forEach(content => {
      content.style.display = content.id === targetId ? "block" : "none";
    });
  }

  // タブクリック時の処理
  tabLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href").replace("#", "");
      activateTabById(targetId);
      history.replaceState(null, "", `#${targetId}`);
    });
  });

  // ページ読み込み時：ハッシュ付き or デフォルト
  const initialHash = window.location.hash.replace("#", "");
  if (initialHash && document.getElementById(initialHash)) {
    activateTabById(initialHash);
  } else if (tabLinks.length > 0) {
    const firstId = tabLinks[0].getAttribute("href").replace("#", "");
    activateTabById(firstId);
  }
});
